import React, { Component } from 'react';
import '../Styles/Buttons.css';

export default class Button extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'empty',
      clicked: -1,
    };
  }

  handleClick(number) {
    this.props.onClick(number)
    this.setState({
      clicked: number
    })
  }

  render(){

    var filled = {
      'backgroundColor': `${this.props.color}`,
      'font-weight': '900',
      'color': 'white'
    }

    var empty = {
      'backgroundColor': 'white',
    }

    const numberButtons = this.props.numbers.map((number) =>
      <button
          onClick={() => this.handleClick(number)}
          className="height-button" 
          style={this.state.clicked === number ? filled : empty}
      >
          {number}
      </button>
    );



    return (
      <div className='height-button-container'>
        <div className='height-buttons'>
          {numberButtons}
        </div>
      </div>
    );

  }
}